import React from 'react';
import { connect } from 'react-redux';

import { resendVerificationEmail } from 'src/actions';
import { EmailVerificationRequiredComponent } from './email-verification-required-component';
import { AppDispatch } from 'src/store';

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  resendVerificationEmail: dispatch(resendVerificationEmail()),
});

export const EmailVerificationRequiredContainer = connect(
  undefined,
  mapDispatchToProps
)(EmailVerificationRequiredComponent);
